// In-app navigation primitives.
//
// `Link` is the network-aware wrapper from `./network-link` — every
// callsite that imports `Link` from this module gets demo-mode prefix
// rewriting for free. See `network-link.tsx` for the rewrite rules.
//
// `useRouter`, `redirect`, `usePathname`, `getPathname` are passed
// through unmodified — callers that use them already know what URL
// form they want (e.g. the network toggle uses raw next/navigation
// router because it owns the URL flip explicitly).

import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

type Navigation = ReturnType<typeof createNavigation>;
const navigation: Navigation = createNavigation(routing);

export { NetworkLink as Link } from './network-link';
export const redirect: Navigation['redirect'] = navigation.redirect;
export const usePathname: Navigation['usePathname'] = navigation.usePathname;
export const useRouter: Navigation['useRouter'] = navigation.useRouter;
export const getPathname: Navigation['getPathname'] = navigation.getPathname;
